module.exports = __webpack_public_path__ + "static/media/map-pin.5d2a13e3.svg";